import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { cardStyles } from './eventDetailsStyles';

const NeedHelpCard = ({ contactDetails }) => {
  const name = contactDetails?.name || 'Events Team';
  const email = contactDetails?.email || 'events@sidra.org';
  const phone = contactDetails?.phone || '';
  const alternatePhone = contactDetails?.phone_alt || '';
  const hours = contactDetails?.hours || '';
  const timezone = contactDetails?.timezone || '';
  const notes = contactDetails?.notes || '';

  return (
    <Card sx={cardStyles.rounded}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Need Help?</Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>{`Contact ${name} for any questions.`}</Typography>

        <Stack spacing={0.5} sx={{ mb: 2 }}>
          {phone && (
            <Typography variant="body2" color="text.secondary">
              Phone: <a href={`tel:${phone}`} style={{ color: 'inherit' }}>{phone}</a>
            </Typography>
          )}
          {alternatePhone && (
            <Typography variant="body2" color="text.secondary">
              Alternate Phone: <a href={`tel:${alternatePhone}`} style={{ color: 'inherit' }}>{alternatePhone}</a>
            </Typography>
          )}
          {hours && <Typography variant="body2" color="text.secondary">{`Hours: ${hours}`}</Typography>}
          {timezone && <Typography variant="body2" color="text.secondary">{`Timezone: ${timezone}`}</Typography>}
          {notes && <Typography variant="body2" color="text.secondary">{notes}</Typography>}
        </Stack>

        <Button fullWidth variant="outlined" href={`mailto:${email}`}>Email Support</Button>
      </CardContent>
    </Card>
  );
};

export default NeedHelpCard;
